import React from 'react';

export default function Modal({ isOpen, onClose, title, children, large, xl }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={`modal ${xl ? 'modal-xl' : large ? 'modal-lg' : ''}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        {children}
      </div>
    </div>
  );
}
